import { Avatar, Button, FormControl, MenuItem, Select, Typography } from '@mui/material';
import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Company } from '../../../core/interfaces/company.interface';
import React from 'react';
import ApartmentIcon from '@mui/icons-material/Apartment';
import { useUserCore } from '../../../core/modules/user';
import { useCompanyCore } from '../../../core/modules/company';
import { useGlobalCore } from '../../../core/modules/global';
import { UserCompany } from '../../../core/interfaces/userCompany.interface';
import { UserType } from '../../../core/enums/userType.enum';

interface Props {
  company: Company;
  companies: UserCompany[];
}

function CompanyItem(props: Props) {
  const { company, companies } = props;
  const { t } = useTranslation();
  const { user, getCompanies } = useUserCore();
  const { postUser } = useCompanyCore();
  const { closeDialog } = useGlobalCore();

  const [role, setRole] = useState(UserType.user);
  
  const isAssigned = useMemo(() =>
    companies.some((uCompany) => uCompany.company.id === company.id)
  , [company.id, companies]);

  const onAssigning = useCallback(() => {
    postUser(company.id, { userId: user?.id!, role }, () => {
      getCompanies(user?.id!);
      closeDialog();
    });
  }, [postUser, company.id, user?.id, role, getCompanies, closeDialog]);

  return (
    <div className="py-16 flex flex-col justify-center sm:justify-between flex-wrap">
      <div className="flex justify-center items-center">
        <Avatar alt="company photo" src={company.selectedAvatar} className="mr-8">
          <ApartmentIcon fontSize="large" />
        </Avatar>
        <Typography className="font-medium leading-5 truncate text-slate-950">
          {company.name}
        </Typography>
      </div>

      <div className="flex mt-12">
        <FormControl className="flex w-full" variant="outlined" size="small">
          <Select
            labelId="user-role-label"
            value={role}
            className="w-[200px]"
            onChange={(ev) => setRole(ev.target.value as UserType)}
            size="small"
          >
            <MenuItem value={UserType.admin}>Admin</MenuItem>
            <MenuItem value={UserType.user}>Usuario</MenuItem>
          </Select>
        </FormControl>
        <Button
          variant="contained"
          color="secondary"
          sx={{ borderRadius: 50 }}
          onClick={onAssigning}
          disabled={isAssigned}
        >
          {isAssigned ? t('button.assigned') : t('button.assign')}
        </Button>
      </div>
    </div>
  );
}

export default CompanyItem;
